import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useNav } from '../hooks/useNav'
import { supabase } from '../lib/supabase'
import { idFromSlug } from '../lib/slug'
import { useAuth } from '../context/AuthContext'
import { applyB2CMarkup } from '../lib/b2cPricing'
import { useExchangeRate } from '../hooks/useExchangeRate'
import { useCurrency } from '../context/CurrencyContext'
import Topbar from '../components/Topbar'
import Footer from '../components/Footer'

const WHATSAPP_NUMBERS = {
  Watches: '18488639660',
  Bags: '18254757069',
  Jewellery: '17325061373',
}
const SUPABASE_URL = 'https://tulqgebsvpxgwocptnmy.supabase.co'
const ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR1bHFnZWJzdnB4Z3dvY3B0bm15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2MjYzOTEsImV4cCI6MjA5MDIwMjM5MX0.H12dPM59cIxlvpR7jbuDjpX11qNdohvi-nhiMxNheJA'

async function notifyOffer(payload) {
  try {
    await fetch(`${SUPABASE_URL}/functions/v1/notify-offer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${ANON_KEY}` },
      body: JSON.stringify(payload)
    })
  } catch (err) {
    console.log('Notify error:', err)
  }
}

function cleanRef(ref) {
  if (!ref) return ''
  if (ref.includes('/')) return ref.split('/').filter(Boolean).pop()
  const numericSuffix = ref.match(/(\d+)$/)
  if (numericSuffix) return numericSuffix[1]
  return ref
}
const CATEGORIES = ['Watches', 'Jewellery', 'Bags']

const CONDITIONS = [
  'pre-owned conditions with MINOR signs of usage',
  'pre-owned conditions with MAJOR signs of usage',
  'Fair',
  'Needs Repair',
  'Repaired',
  'Repaired Albania',
  'Pre-owned',
  'Brand New',
]

const BRANDS = [
  'A. Lange & Söhne','Audemars Piguet','Balenciaga','Blancpain','Bottega Veneta',
  'Breguet','Breitling','Bulgari','Cartier','Celine','Chanel','Chopard','De Beers',
  'Dior','Fendi','Girard-Perregaux','Graff','Grand Seiko','Gucci','Harry Winston',
  'Hermès','Hublot','IWC','Jaeger-LeCoultre','Loewe','Louis Vuitton','Mikimoto',
  'Omega','Other','Panerai','Patek Philippe','Piaget','Prada','Richard Mille','Rolex',
  'Saint Laurent','TAG Heuer','Tiffany & Co','Tudor','Ulysse Nardin','Vacheron Constantin',
  'Van Cleef & Arpels','Zenith'
]

export default function WatchDetail() {
  const { slug } = useParams()
  const navigate = useNav()
  const { profile } = useAuth()

  function goBack() {
    if (window.history.state?.idx > 0) {
      navigate(-1)
    } else {
      const cat = watch?.category
      navigate(cat === 'Bags' ? '/bags' : cat === 'Jewellery' ? '/jewellery' : '/watches')
    }
  }
  const { rate } = useExchangeRate()
  const { currency } = useCurrency()
  const [watch, setWatch] = useState(null)
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(true)
  const [msg, setMsg] = useState('')
  const [lightbox, setLightbox] = useState(null)
  const [activeImg, setActiveImg] = useState(0)
  const [editing, setEditing] = useState(false)
  const [editForm, setEditForm] = useState({})
  const [saving, setSaving] = useState(false)
  const [uploadingImg, setUploadingImg] = useState(false)
  const [dragIndex, setDragIndex] = useState(null)
  const [offerModal, setOfferModal] = useState(false)
  const [offerPrice, setOfferPrice] = useState('')
  const [offerComment, setOfferComment] = useState('')
  const [offerPhone, setOfferPhone] = useState('')
  const [submittingOffer, setSubmittingOffer] = useState(false)
  const [isPreorder, setIsPreorder] = useState(false)
  const [myOffer, setMyOffer] = useState(null)

  const fetchWatch = useCallback(async () => {
    const itemId = idFromSlug(slug)

    const { data } = await supabase
      .from('products')
      .select('*, product_images(id, url, position), profiles!posted_by(full_name)')
      .eq('id', itemId)
      .single()
    if (data) {
      setWatch(data)
      setIsPreorder(false)
      setImages([...(data.product_images || [])].sort((a, b) => a.position - b.position))
      setEditForm({
        category: data.category || 'Watches',
        brand: data.brand || '',
        model: data.model || '',
        reference: data.reference || '',
        condition: data.condition || '',
        price_usd: data.price_usd || '',
        price_eur: data.price_eur || '',
        cost_eur: data.cost_eur || '',
        cost_cny: data.cost_cny || '',
        vendor: data.vendor || '',
        notes: data.notes || '',
        metal_type: data.metal_type || '',
        subcategory: data.subcategory || '',
        item_size: data.item_size || '',
        scope_of_delivery: data.scope_of_delivery || '',
      })
      setLoading(false)
      return
    }
    const { data: preorder } = await supabase.from('preorders').select('*').eq('id', itemId).single()
    if (preorder) {
      const [{ data: agentProfile }, { data: preorderImgs }] = await Promise.all([
        preorder.posted_by
          ? supabase.from('profiles').select('full_name').eq('id', preorder.posted_by).single()
          : Promise.resolve({ data: null }),
        supabase.from('preorder_images').select('id, url, position').eq('preorder_id', preorder.id).order('position')
      ])
      setWatch({ ...preorder, product_images: preorderImgs || [], profiles: agentProfile || null })
      setIsPreorder(true)
      setImages([...(preorderImgs || [])].sort((a, b) => a.position - b.position))
      setEditForm({
        category: preorder.category || 'Watches',
        brand: preorder.brand || '',
        model: preorder.model || '',
        reference: preorder.reference || '',
        condition: preorder.condition || 'Pre-owned',
        price_usd: preorder.price_usd || '',
        price_eur: preorder.price_eur || '',
        cost_eur: preorder.cost_eur || '',
        cost_cny: preorder.cost_cny || '',
        vendor: preorder.vendor || '',
        notes: preorder.notes || '',
        metal_type: preorder.metal_type || '',
        subcategory: preorder.subcategory || '',
        item_size: preorder.item_size || '',
        scope_of_delivery: preorder.scope_of_delivery || '',
      })
    }
    setLoading(false)
  }, [slug])

  const fetchMyOffer = useCallback(async () => {
    if (profile?.role !== 'dealer' || !watch?.id) return
    const { data } = await supabase
      .from('offers')
      .select('*')
      .eq('watch_id', watch.id)
      .eq('dealer_id', profile.id)
      .in('status', ['pending', 'countered'])
      .maybeSingle()
    setMyOffer(data || null)
  }, [watch?.id, profile])

  useEffect(() => { fetchWatch() }, [fetchWatch])
  useEffect(() => { fetchMyOffer() }, [fetchMyOffer])

  useEffect(() => {
    function onKey(e) {
      if (lightbox === null) return
      if (e.key === 'Escape') setLightbox(null)
      if (e.key === 'ArrowRight') setLightbox(i => Math.min(i + 1, images.length - 1))
      if (e.key === 'ArrowLeft') setLightbox(i => Math.max(i - 1, 0))
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [lightbox, images.length])


  async function handleSaveEdit() {
    setSaving(true)
    const table = isPreorder ? 'preorders' : 'products'
    const { error } = await supabase.from(table).update({
      category: editForm.category || 'Watches',
      brand: editForm.brand,
      model: editForm.model,
      reference: editForm.reference || null,
      condition: editForm.condition,
      price_usd: editForm.price_eur && rate ? Math.round(Number(editForm.price_eur) * rate) : editForm.price_usd ? Number(editForm.price_usd) : null,
      price_eur: editForm.price_eur ? Number(editForm.price_eur) : null,
      cost_eur: editForm.cost_eur ? Number(editForm.cost_eur) : null,
      cost_cny: editForm.cost_cny ? Number(editForm.cost_cny) : null,
      vendor: editForm.vendor || null,
      notes: editForm.notes || null,
      scope_of_delivery: editForm.scope_of_delivery || null,
      metal_type: editForm.category === 'Jewellery' && editForm.metal_type ? editForm.metal_type : null,
      subcategory: editForm.category === 'Jewellery' && editForm.subcategory ? editForm.subcategory : null,
      item_size: editForm.category === 'Jewellery' && editForm.item_size && editForm.subcategory !== 'Necklaces' ? editForm.item_size : null,
    }).eq('id', watch.id)
    if (!error) {
      // Update watch fields in place — calling fetchWatch() would re-sort images from DB
      // and undo any reordering the user did before hitting Save.
      setWatch(prev => ({
        ...prev,
        category: editForm.category || 'Watches',
        brand: editForm.brand,
        model: editForm.model,
        reference: editForm.reference || null,
        condition: editForm.condition,
        price_eur: editForm.price_eur ? Number(editForm.price_eur) : null,
        cost_eur: editForm.cost_eur ? Number(editForm.cost_eur) : null,
        vendor: editForm.vendor || null,
        notes: editForm.notes || null,
        scope_of_delivery: editForm.scope_of_delivery || null,
        metal_type: editForm.metal_type || null,
        subcategory: editForm.subcategory || null,
        item_size: editForm.item_size || null,
      }))
      setEditing(false)
      setMsg('Updated successfully.')
    }
    setSaving(false)
  }

  async function handleDeleteListing() {
    if (!window.confirm('Delete this listing permanently? This cannot be undone.')) return
    if (isPreorder) {
      await supabase.from('preorders').delete().eq('id', watch.id)
    } else {
      for (const img of images) {
        const path = img.url.split('/object/public/watch-images/')[1]
        if (path) await supabase.storage.from('watch-images').remove([decodeURIComponent(path)])
      }
      await supabase.from('product_images').delete().eq('product_id', watch.id)
      await supabase.from('products').delete().eq('id', watch.id)
    }
    goBack()
  }

  async function handleSetMain(targetIndex) {
    if (targetIndex === 0) return
    await handleReorderImages(targetIndex, 0)
  }

  async function handleReorderImages(fromIndex, toIndex) {
    if (fromIndex === toIndex) return
    const reordered = [...images]
    const [moved] = reordered.splice(fromIndex, 1)
    reordered.splice(toIndex, 0, moved)
    setImages(reordered)
    setActiveImg(toIndex)
    const imgTable = isPreorder ? 'preorder_images' : 'product_images'
    // Two-pass update to avoid UNIQUE(product_id, position) conflicts during reorder:
    // Pass 1 — shift to large temp positions so no two rows share a real position
    await Promise.all(reordered.map((img, i) =>
      supabase.from(imgTable).update({ position: 10000 + i }).eq('id', img.id)
    ))
    // Pass 2 — set the actual positions
    const results = await Promise.all(reordered.map((img, i) =>
      supabase.from(imgTable).update({ position: i }).eq('id', img.id)
    ))
    const failed = results.find(r => r.error)
    if (failed) setMsg('⚠️ Position not saved: ' + failed.error.message)
  }

  async function handleDeleteImage(img) {
    const path = img.url.split('/object/public/watch-images/')[1]
    if (path) await supabase.storage.from('watch-images').remove([decodeURIComponent(path)])
    const imgTable = isPreorder ? 'preorder_images' : 'product_images'
    await supabase.from(imgTable).delete().eq('id', img.id)
    // Keep the current visual order (images array is already correctly ordered after any reorder)
    const remaining = images.filter(i => i.id !== img.id)
    await Promise.all(remaining.map((r, idx) =>
      supabase.from(imgTable).update({ position: idx }).eq('id', r.id)
    ))
    setActiveImg(0)
    await fetchWatch()
  }

  async function handleAddImages(e) {
    const files = Array.from(e.target.files)
    if (!files.length) return
    setUploadingImg(true)
    setMsg('')
    const imgTable = isPreorder ? 'preorder_images' : 'product_images'
    const fkCol = isPreorder ? 'preorder_id' : 'product_id'
    let uploaded = 0
    const newIds = []
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const ext = file.name.split('.').pop()
      const path = `${watch.id}/${Date.now()}_${i}.${ext}`
      const { error: upErr } = await supabase.storage.from('watch-images').upload(path, file)
      if (upErr) { setMsg(`Upload failed: ${upErr.message}`); continue }
      const { data: { publicUrl } } = supabase.storage.from('watch-images').getPublicUrl(path)
      // Insert at temp position — renumber everything after the loop
      const { data: row, error: dbErr } = await supabase.from(imgTable).insert({ [fkCol]: watch.id, url: publicUrl, position: 99999 + uploaded }).select('id').single()
      if (dbErr) { setMsg(`Save failed: ${dbErr.message}`); continue }
      newIds.push(row.id)
      uploaded++
    }
    // Renumber all images (existing in current order, then new ones appended),
    // so positions are always 0,1,2… with no gaps regardless of prior state.
    const allIds = [...images.map(img => img.id), ...newIds]
    await Promise.all(allIds.map((id, i) => supabase.from(imgTable).update({ position: 10000 + i }).eq('id', id)))
    await Promise.all(allIds.map((id, i) => supabase.from(imgTable).update({ position: i }).eq('id', id)))
    setUploadingImg(false)
    if (uploaded > 0) setMsg('')
    await fetchWatch()
  }

  async function handleSubmitOffer() {
    if (!offerPrice) return
    setSubmittingOffer(true)
    const { data: offer, error } = await supabase.from('offers').insert({
      watch_id: watch.id,
      dealer_id: profile.id,
      dealer_whatsapp: offerPhone || null,
      offer_price: Number(offerPrice),
      status: 'pending',
      dealer_comment: offerComment || null,
    }).select().single()
    if (error) {
      console.error('Offer insert error:', error)
      setMsg('Failed to submit offer. Please try again.')
    } else {
      notifyOffer({
        action: 'new_offer',
        watch: { brand: watch.brand, model: watch.model },
        dealer_name: profile.full_name,
        dealer_whatsapp: offerPhone || null,
        offer_price: Number(offerPrice),
        dealer_comment: offerComment || null,
      })
      setMyOffer(offer)
      setOfferModal(false)
      setOfferPrice('')
      setOfferComment('')
      setOfferPhone('')
      setMsg('Offer submitted — the agent will be in touch.')
    }
    setSubmittingOffer(false)
  }

  function handleShare() {
    const url = window.location.href
    if (navigator.share) {
      navigator.share({ title: `${watch.brand} ${watch.model}`, url })
    } else {
      navigator.clipboard.writeText(url)
      setMsg('Link copied to clipboard.')
    }
  }

  function handleWhatsApp() {
    const price = currency === 'EUR' && displayEur
      ? `€${displayEur.toLocaleString()}`
      : (!isB2C && watch.price_usd) ? `$${Number(watch.price_usd).toLocaleString()}` : (displayEur && rate ? `$${Math.round(displayEur * rate).toLocaleString()}` : '')
    const text = `Hi, I'm interested in this item from Brandville Vault:\n\n${watch.brand} ${watch.model}${watch.reference ? ` (${watch.reference})` : ''}\n${price}\n\n${window.location.href}`
    const waNumber = WHATSAPP_NUMBERS[watch.category] || WHATSAPP_NUMBERS.Watches
    window.open(`https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`, '_blank')
  }

  if (loading) return <div className="loading-page"><div className="spinner" /></div>
  if (!watch) return <div className="page"><div className="empty-state">Item not found</div></div>

  const isB2C = profile?.role === 'b2c'
  const displayEur = isB2C
    ? applyB2CMarkup(watch.price_eur, { category: watch.category, costEur: watch.cost_eur, b2cPriceEur: watch.b2c_price_eur })
    : (watch.price_eur ? Number(watch.price_eur) : null)

  const priceMain = currency === 'USD'
    ? (displayEur && rate
        ? `$${Math.round(displayEur * rate).toLocaleString()}`
        : (!isB2C && watch.price_usd) ? `$${Number(watch.price_usd).toLocaleString()}` : '—')
    : (displayEur ? `€${displayEur.toLocaleString()}` : '—')

  const priceSecondary = currency === 'USD' && displayEur
    ? `€${displayEur.toLocaleString()} EUR`
    : currency === 'EUR' && displayEur && rate
      ? `$${Math.round(displayEur * rate).toLocaleString()} USD`
      : null

  const b2bEur = Number(watch.b2b_price_eur) > 0 ? Number(watch.b2b_price_eur) : null
  const b2bUsd = b2bEur && rate ? `$${Math.round(b2bEur * rate).toLocaleString()}` : null
  const b2bEurStr = b2bEur ? `€${b2bEur.toLocaleString()}` : null
  const b2bMain = currency === 'USD' && b2bUsd ? b2bUsd : b2bEurStr
  const b2bSecondary = currency === 'USD' ? (b2bUsd ? b2bEurStr : null) : b2bUsd

  const canEdit = profile?.role === 'admin' || profile?.role === 'agent'

  function handleBrandClick() {
    const route = watch.category === 'Jewellery' ? '/jewellery' : watch.category === 'Bags' ? '/bags' : '/watches'
    navigate(`${route}?brand=${encodeURIComponent(watch.brand)}`)
  }

  return (
    <div className="page" style={{ background: '#ffffff' }}>
      <Topbar />

      {/* Back + Edit bar */}
      <div style={{ maxWidth: 940, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px' }}>
        <button className="btn btn-sm" onClick={goBack}>← Back</button>
        <div style={{ display: 'flex', gap: 8 }}>
          {canEdit && !editing && <button className="btn btn-sm" onClick={() => setEditing(true)}>Edit</button>}
          {editing && <button className="btn btn-sm" onClick={() => setEditing(false)}>Cancel</button>}
          {profile?.role === 'admin' && !editing && <button className="btn btn-sm" onClick={handleDeleteListing} style={{ color: '#c00', borderColor: '#f09595' }}>Delete</button>}
        </div>
      </div>

      {msg && <div className="success-msg" style={{ maxWidth: 940, margin: '0 auto 4px', padding: '0 20px' }}><div>{msg}</div></div>}

      {/* 2-column layout */}
      <div className="detail-layout">

        {/* LEFT — images */}
        <div className="detail-left">
          <div style={{ position: 'relative', background: '#f5f2ed', borderRadius: 16, overflow: 'hidden', aspectRatio: '1/1', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 20px rgba(0,0,0,0.06)' }}>
            {images.length > 0 ? (
              <>
                <img
                  src={images[activeImg]?.url}
                  alt={watch.model}
                  style={{ width: '100%', height: '100%', objectFit: 'contain', cursor: 'zoom-in' }}
                  onClick={() => setLightbox(activeImg)}
                />
                {images.length > 1 && activeImg > 0 && (
                  <button onClick={e => { e.stopPropagation(); setActiveImg(i => Math.max(i - 1, 0)) }} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: '#fff', border: 'none', boxShadow: '0 2px 14px rgba(0,0,0,0.14)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, color: '#333', zIndex: 2, fontFamily: 'inherit', lineHeight: 1 }}>‹</button>
                )}
                {images.length > 1 && activeImg < images.length - 1 && (
                  <button onClick={e => { e.stopPropagation(); setActiveImg(i => Math.min(i + 1, images.length - 1)) }} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: '#fff', border: 'none', boxShadow: '0 2px 14px rgba(0,0,0,0.14)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, color: '#333', zIndex: 2, fontFamily: 'inherit', lineHeight: 1 }}>›</button>
                )}
                {images.length > 1 && (
                  <div style={{ position: 'absolute', bottom: 14, display: 'flex', gap: 6 }}>
                    {images.map((_, i) => (
                      <div key={i} onClick={() => setActiveImg(i)} style={{ width: 7, height: 7, borderRadius: '50%', background: i === activeImg ? '#b8965a' : 'rgba(0,0,0,0.18)', cursor: 'pointer', transition: 'background 0.15s' }} />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <span style={{ fontSize: 48 }}>⌚</span>
            )}
          </div>

          {/* Thumbnails — show strip whenever there are images, or when editing (for + button) */}
          {images.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
              {images.map((img, i) => (
                <div
                  key={img.url}
                  draggable={editing}
                  onDragStart={e => { if (!editing) { e.preventDefault(); return; } setDragIndex(i) }}
                  onDragOver={e => { if (editing) e.preventDefault() }}
                  onDrop={() => { if (editing) { handleReorderImages(dragIndex, i); setDragIndex(null) } }}
                  onDragEnd={() => setDragIndex(null)}
                  style={{ position: 'relative', opacity: dragIndex === i ? 0.4 : 1, cursor: editing ? 'grab' : 'pointer' }}
                >
                  <img
                    src={img.url}
                    alt=""
                    draggable={false}
                    onClick={() => setActiveImg(i)}
                    style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 10, border: i === 0 ? '2px solid #b8965a' : i === activeImg ? '2px solid var(--gold)' : '2px solid transparent', outline: i === activeImg ? 'none' : '1px solid var(--border)', pointerEvents: 'auto', cursor: 'pointer', transition: 'border-color 0.15s' }}
                  />
                  {i === 0 && (
                    <div style={{ position: 'absolute', bottom: editing ? 28 : 4, left: 0, right: 0, textAlign: 'center', pointerEvents: 'none' }}>
                      <span style={{ background: '#b8965a', color: '#fff', fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 4, letterSpacing: '0.05em' }}>MAIN</span>
                    </div>
                  )}
                  {editing && (
                    <button onClick={() => handleDeleteImage(img)} style={{ position: 'absolute', top: -6, right: -6, width: 18, height: 18, borderRadius: '50%', background: '#e00', color: '#fff', border: 'none', fontSize: 11, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                  )}
                  {editing && (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 2, marginTop: 3 }}>
                      <button onClick={() => i > 0 && handleReorderImages(i, i - 1)} disabled={i === 0} style={{ width: 24, height: 20, fontSize: 12, border: '1px solid var(--border)', borderRadius: 4, background: 'var(--surface)', cursor: i === 0 ? 'default' : 'pointer', opacity: i === 0 ? 0.3 : 1 }}>←</button>
                      {canEdit && i !== 0 && (
                        <button onClick={() => handleSetMain(i)} title="Set as main" style={{ width: 22, height: 20, fontSize: 11, border: '1px solid #b8965a', borderRadius: 4, background: 'var(--surface)', color: '#b8965a', cursor: 'pointer', lineHeight: 1 }}>★</button>
                      )}
                      {i === 0 && <div style={{ width: 22 }} />}
                      <button onClick={() => i < images.length - 1 && handleReorderImages(i, i + 1)} disabled={i === images.length - 1} style={{ width: 24, height: 20, fontSize: 12, border: '1px solid var(--border)', borderRadius: 4, background: 'var(--surface)', cursor: i === images.length - 1 ? 'default' : 'pointer', opacity: i === images.length - 1 ? 0.3 : 1 }}>→</button>
                    </div>
                  )}
                </div>
              ))}
              {editing && (
                <label style={{ width: 72, height: 72, borderRadius: 10, border: '2px dashed var(--gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 22, color: 'var(--gold)', background: 'var(--gold-light)' }}>
                  {uploadingImg ? <span className="spinner" style={{ width: 16, height: 16 }} /> : '+'}
                  <input type="file" accept="image/*" multiple onChange={handleAddImages} style={{ display: 'none' }} />
                </label>
              )}
            </div>
          )}
          {editing && images.length === 0 && (
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, cursor: 'pointer', color: '#8a8078', fontSize: 13 }}>
              {uploadingImg ? <span className="spinner" style={{ width: 16, height: 16 }} /> : '+ Add photos'}
              <input type="file" accept="image/*" multiple onChange={handleAddImages} style={{ display: 'none' }} />
            </label>
          )}
        </div>

        {/* RIGHT — info */}
        <div className="detail-right">
          {editing ? (
            <div style={{ background: 'var(--surface)', borderRadius: 12, padding: 16, marginBottom: 20, border: '1px solid var(--border)' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#8a8078', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: 14 }}>Edit details</div>
              <div className="form-row"><label>Category</label>
                <select value={editForm.category || 'Watches'} onChange={e => setEditForm(f => ({ ...f, category: e.target.value }))}>
                  {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-2col">
                <div className="form-row"><label>Brand</label>
                  <select value={editForm.brand} onChange={e => setEditForm(f => ({ ...f, brand: e.target.value }))}>
                    {BRANDS.map(b => <option key={b}>{b}</option>)}
                  </select>
                </div>
                <div className="form-row"><label>Condition</label>
                  <select value={editForm.condition} onChange={e => setEditForm(f => ({ ...f, condition: e.target.value }))}>
                    {CONDITIONS.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
              </div>
              {editForm.category === 'Jewellery' && (
                <>
                  <div className="form-row"><label>Jewellery type</label>
                    <select value={editForm.subcategory || ''} onChange={e => setEditForm(f => ({ ...f, subcategory: e.target.value, item_size: '' }))}>
                      <option value="">Select type</option>
                      <option>Rings</option><option>Bracelets</option><option>Necklaces</option><option>Earrings</option>
                    </select>
                  </div>
                  <div className="form-row"><label>Metal type</label>
                    <select value={editForm.metal_type || ''} onChange={e => setEditForm(f => ({ ...f, metal_type: e.target.value }))}>
                      <option value="">Select metal</option>
                      <option>Yellow Gold</option><option>Pink Gold</option><option>White Gold</option><option>Platinum</option>
                    </select>
                  </div>
                  {editForm.subcategory === 'Rings' && (
                    <div className="form-row"><label>Ring size</label>
                      <select value={editForm.item_size || ''} onChange={e => setEditForm(f => ({ ...f, item_size: e.target.value }))}>
                        <option value="">Select size</option>
                        {['50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65'].map(s => <option key={s}>{s}</option>)}
                      </select>
                    </div>
                  )}
                  {editForm.subcategory === 'Bracelets' && (
                    <div className="form-row"><label>Bracelet size</label>
                      <select value={editForm.item_size || ''} onChange={e => setEditForm(f => ({ ...f, item_size: e.target.value }))}>
                        <option value="">Select size</option>
                        {['14','15','16','17','18','19','20','21','22','23','XS','S','M','L','XL','XXL','3XL'].map(s => <option key={s}>{s}</option>)}
                      </select>
                    </div>
                  )}
                </>
              )}
              <div className="form-row"><label>Model</label><input value={editForm.model} onChange={e => setEditForm(f => ({ ...f, model: e.target.value }))} /></div>
              <div className="form-row"><label>Reference</label><input value={editForm.reference} onChange={e => setEditForm(f => ({ ...f, reference: e.target.value }))} /></div>
              <div className="form-row"><label>Scope of Delivery</label>
                <select value={editForm.scope_of_delivery || ''} onChange={e => setEditForm(f => ({ ...f, scope_of_delivery: e.target.value }))}>
                  <option value="">—</option>
                  <option>Watch Only</option><option>With Card</option><option>With Box</option><option>Card & Box</option>
                </select>
              </div>
              <div className="form-2col">
                <div className="form-row"><label>Selling Price EUR</label><input type="number" value={editForm.price_eur} onChange={e => setEditForm(f => ({ ...f, price_eur: e.target.value }))} /></div>
                <div className="form-row"><label>Cost Price EUR</label><input type="number" value={editForm.cost_eur} onChange={e => setEditForm(f => ({ ...f, cost_eur: e.target.value }))} placeholder="Internal only" /></div>
                <div className="form-row"><label>Cost Price CNY ¥</label><input type="number" value={editForm.cost_cny} onChange={e => setEditForm(f => ({ ...f, cost_cny: e.target.value }))} placeholder="Internal only" /></div>
              </div>
              <div className="form-row"><label>Vendor</label><input value={editForm.vendor} onChange={e => setEditForm(f => ({ ...f, vendor: e.target.value }))} placeholder="Internal only" /></div>
              <div className="form-row"><label>Notes</label><textarea rows={2} value={editForm.notes} onChange={e => setEditForm(f => ({ ...f, notes: e.target.value }))} /></div>
              <button className="btn btn-dark btn-full" onClick={handleSaveEdit} disabled={saving}>{saving ? '...' : 'Save changes'}</button>
            </div>
          ) : (
            <>
              {/* Header */}
              <div style={{ marginBottom: 24 }}>
                <div className="detail-category">{watch.category || 'Watches'}</div>
                <div className="detail-brand" onClick={handleBrandClick} title={`View all ${watch.brand}`}>
                  {watch.brand}
                  <span className="detail-brand-arrow">↗</span>
                </div>
                <div className="detail-model">{watch.model}</div>
                {(cleanRef(watch.reference) || watch.reference) && (
                  <div className="detail-ref">
                    <span className="detail-ref-label">Ref</span>
                    {cleanRef(watch.reference) || watch.reference}
                  </div>
                )}
              </div>

              {/* Status */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: watch.ready_to_ship ? 8 : 24, paddingBottom: watch.ready_to_ship ? 0 : 24, borderBottom: watch.ready_to_ship ? 'none' : '1px solid var(--border-light)' }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: watch.status === 'available' ? '#16a34a' : watch.status === 'reserved' ? '#d97706' : '#dc2626', flexShrink: 0 }} />
                <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: watch.status === 'available' ? '#16a34a' : watch.status === 'reserved' ? '#d97706' : '#dc2626' }}>{watch.status}</span>
              </div>
              {watch.ready_to_ship && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 24, paddingBottom: 24, borderBottom: '1px solid var(--border-light)' }}>
                  <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', background: 'rgba(15,118,110,0.12)', color: '#0f766e', padding: '3px 10px', borderRadius: 20 }}>Ready to ship</span>
                </div>
              )}

              {/* Price */}
              <div style={{ marginBottom: 24, paddingBottom: 24, borderBottom: '1px solid var(--border-light)' }}>
                {!isB2C && b2bMain ? (
                  <>
                    <div className="detail-price">{b2bMain}</div>
                    {b2bSecondary && <div className="detail-price-secondary">≈ {b2bSecondary} {currency === 'USD' ? 'EUR' : 'USD'}</div>}
                  </>
                ) : (
                  <>
                    <div className="detail-price">{priceMain}</div>
                    {priceSecondary && <div className="detail-price-secondary">≈ {priceSecondary}</div>}
                  </>
                )}
                {canEdit && (watch.cost_eur || watch.cost_cny || watch.vendor) && (
                  <div style={{ fontSize: 12, color: 'var(--gold)', marginTop: 8, fontWeight: 500 }}>
                    {watch.cost_eur && <>Cost: €{Number(watch.cost_eur).toLocaleString()}</>}
                    {watch.cost_cny && <> · ¥{Number(watch.cost_cny).toLocaleString()} CNY</>}
                    {(watch.cost_eur || watch.cost_cny) && watch.vendor && '  ·  '}
                    {watch.vendor && <>Vendor: {watch.vendor}</>}
                  </div>
                )}
              </div>

              {/* Specs */}
              {(() => {
                const isBags = watch.category === 'Bags'
                const isInternal = profile?.role === 'admin' || profile?.role === 'agent' || profile?.role === 'jewellery_agent'
                let displayGender = null, displayColor = null, displayNotes = watch.notes || null
                if (watch.notes) {
                  const remaining = []
                  for (const part of watch.notes.split(' | ')) {
                    if (part.startsWith('Gender: ')) displayGender = part.slice(8)
                    else if (part.startsWith('Color: ')) displayColor = part.slice(7)
                    else remaining.push(part)
                  }
                  displayNotes = remaining.join(' | ') || null
                }
                // Suppress Zoho auto-generated descriptions for dealers/b2c only —
                // admin/agents see raw notes. Pattern: "12345 - Brand - Reference..."
                if (!isInternal && displayNotes && /^\d+\s*-\s*\S/.test(displayNotes.trim())) {
                  displayNotes = null
                }
                return (
                  <div className="detail-meta" style={{ marginBottom: 24 }}>
                    <div className="detail-meta-row">
                      <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>Condition</span>
                      <span>{watch.condition}</span>
                    </div>
                    {watch.scope_of_delivery && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>Scope of delivery</span>
                        <span>{watch.scope_of_delivery}</span>
                      </div>
                    )}
                    {watch.subcategory && !isBags && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>Type</span>
                        <span>{watch.subcategory}</span>
                      </div>
                    )}
                    {watch.metal_type && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>Metal</span>
                        <span>{watch.metal_type}</span>
                      </div>
                    )}
                    {displayGender && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M12 12v9M9 18h6"/></svg>Gender</span>
                        <span>{displayGender}</span>
                      </div>
                    )}
                    {displayColor && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="10.5" r="2.5"/><circle cx="8.5" cy="7.5" r="2.5"/><circle cx="6.5" cy="12.5" r="2.5"/><path d="M12 22C6.5 22 2 17.5 2 12s4.5-10 10-10c.926 0 1.648 1.175 1.025 1.887L12 5c-.539.617-.1 1.5.642 1.5H16c1.1 0 2 .9 2 2v.5"/></svg>Color</span>
                        <span>{displayColor}</span>
                      </div>
                    )}
                    {watch.item_size && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M2 12h4M18 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>Size</span>
                        <span>{watch.item_size}</span>
                      </div>
                    )}
                    {displayNotes && (
                      <div className="detail-meta-row">
                        <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>Notes</span>
                        <span>{displayNotes}</span>
                      </div>
                    )}
                    {profile?.role !== 'dealer' && (
                    <div className="detail-meta-row">
                      <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>Agent</span>
                      {watch.profiles?.full_name && watch.posted_by
                        ? <span onClick={() => navigate(`/agent/${watch.posted_by}`)} style={{ cursor: 'pointer', textDecoration: 'underline', textUnderlineOffset: 3 }}>{watch.profiles.full_name}</span>
                        : <span>—</span>}
                    </div>
                    )}
                    {profile?.role !== 'dealer' && (
                    <div className="detail-meta-row">
                      <span className="detail-meta-key"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>Posted</span>
                      <span>{new Date(watch.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                    </div>
                    )}
                  </div>
                )
              })()}

              {/* Actions */}
              <div className="detail-actions" style={{ marginBottom: 14 }}>
                <button className="btn btn-green detail-btn-icon" onClick={handleWhatsApp}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  WhatsApp
                </button>
                <button className="btn detail-btn-icon" onClick={handleShare}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                  Share
                </button>
              </div>

              {/* Authenticity banner */}
              <div className="detail-auth-banner">
                <div className="detail-auth-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                </div>
                <div>
                  <div className="detail-auth-title">Authenticity guaranteed</div>
                  <div className="detail-auth-sub">All items are authenticated and inspected by our specialists.</div>
                </div>
              </div>

              {profile?.role === 'dealer' && watch.status === 'available' && watch.source !== 'odoo_bags' && (
                <div style={{ marginTop: 12 }}>
                  {myOffer && (
                    <div style={{ fontSize: 13, color: 'var(--gold)', padding: '8px 12px', background: 'var(--gold-light)', borderRadius: 8, border: '1px solid rgba(184,150,106,0.3)' }}>
                      Offer pending — <strong>€{Number(myOffer.offer_price).toLocaleString()}</strong>
                      {myOffer.status === 'countered' && ` · Counter: €${Number(myOffer.counter_price).toLocaleString()}`}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>

      </div>

      {/* Offer Modal */}
      {offerModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setOfferModal(false)}>
          <div style={{ background: 'var(--surface)', borderRadius: 16, padding: 24, width: '100%', maxWidth: 420, boxShadow: '0 8px 40px rgba(0,0,0,0.6)', border: '1px solid var(--border)' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Make an Offer</div>
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 20 }}>{watch.brand} {watch.model} · Listed at {priceMain}</div>

            <div className="form-row">
              <label>Your offer price (€ EUR)</label>
              <input
                type="number"
                value={offerPrice}
                onChange={e => setOfferPrice(e.target.value)}
                placeholder="e.g. 28000"
                autoFocus
              />
            </div>

            <div className="form-row">
              <label>Comment <span style={{ color: '#bbb', fontWeight: 400 }}>(optional)</span></label>
              <textarea
                rows={3}
                value={offerComment}
                onChange={e => setOfferComment(e.target.value)}
                placeholder="Any notes for the agent..."
              />
            </div>

            <div className="form-row">
              <label>Your WhatsApp number <span style={{ color: '#bbb', fontWeight: 400 }}>(for updates)</span></label>
              <input
                type="tel"
                value={offerPhone}
                onChange={e => setOfferPhone(e.target.value)}
                placeholder="e.g. 355691234567"
              />
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button className="btn btn-dark" style={{ flex: 1 }} onClick={handleSubmitOffer} disabled={submittingOffer || !offerPrice}>
                {submittingOffer ? '...' : 'Submit Offer'}
              </button>
              <button className="btn" onClick={() => setOfferModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <Footer />

      {/* Lightbox */}
      {lightbox !== null && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.93)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setLightbox(null)}>
          <button onClick={() => setLightbox(null)} style={{ position: 'absolute', top: 20, right: 24, background: 'none', border: 'none', color: '#fff', fontSize: 36, cursor: 'pointer', lineHeight: 1 }}>×</button>
          {images.length > 1 && lightbox > 0 && (
            <button onClick={e => { e.stopPropagation(); setLightbox(i => i - 1) }} style={{ position: 'absolute', left: 16, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: 28, width: 48, height: 48, borderRadius: '50%', cursor: 'pointer' }}>‹</button>
          )}
          <img src={images[lightbox].url} alt={watch.model} style={{ maxWidth: '92vw', maxHeight: '92vh', objectFit: 'contain', borderRadius: 8 }} onClick={e => e.stopPropagation()} />
          {images.length > 1 && lightbox < images.length - 1 && (
            <button onClick={e => { e.stopPropagation(); setLightbox(i => i + 1) }} style={{ position: 'absolute', right: 16, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: 28, width: 48, height: 48, borderRadius: '50%', cursor: 'pointer' }}>›</button>
          )}
          {images.length > 1 && (
            <div style={{ position: 'absolute', bottom: 24, display: 'flex', gap: 7 }}>
              {images.map((_, i) => (
                <div key={i} onClick={e => { e.stopPropagation(); setLightbox(i) }} style={{ width: 8, height: 8, borderRadius: '50%', background: i === lightbox ? '#b8965a' : 'rgba(255,255,255,0.35)', cursor: 'pointer', transition: 'background 0.15s' }} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
